import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/page.tsx");
